// @flow
import { get } from "../../utils/helpers/objects";

import { ThemePropertyException } from "../../exceptions";

import type { Theme, ThemePropValue } from "../types";

/**
 */
export const getProp = (
  theme: $Shape<Theme> = {},
  path: string = "",
  defaultValue: ThemePropValue = "",
): ?ThemePropValue => {
  return path === "" ? defaultValue : get(theme, path, defaultValue);
};

/**
 */
export const getThemeProp = (
  theme: $Shape<Theme> = {},
  path: string = "",
  defaultValue: ThemePropValue = "",
): ThemePropValue => {
  const value = getProp(theme, path, defaultValue);

  if (
    value != null &&
    (typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "object")
  ) {
    return value;
  }

  throw new ThemePropertyException(
    `${path} is not a string, number or plain object, but: ${typeof value}`,
  );
};

/**
 */
export const getThemeStringProp = (
  theme: $Shape<Theme> = {},
  path: string = "",
  defaultValue: string = "",
): string => {
  const value = getProp(theme, path, defaultValue);

  if (typeof value === "string") {
    return value;
  } else if (typeof value === "number") {
    return value.toString();
  }

  throw new ThemePropertyException(
    `${path} is not a string, but: ${typeof value}`,
  );
};

/**
 */
export const getThemeNumberProp = (
  theme: $Shape<Theme> = {},
  path: string = "",
  defaultValue: number = 0,
): number => {
  const value = getProp(theme, path, defaultValue);

  if (typeof value === "number") {
    return value;
  }

  throw new ThemePropertyException(
    `${path} is not a number, but: ${typeof value}`,
  );
};

/*
 * Retrieve property value from theme property of styled component
 */
/**
 */
export const themeProp =
  (
    path: string,
    defaultValue?: ThemePropValue,
  ): (({ theme: Theme }) => ThemePropValue) =>
  ({ theme }: { theme: Theme }) =>
    getThemeProp(theme, path, defaultValue);
